var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.5V0.5H21.5V21.5H0.5ZM2.83333 19.1667H19.1667V2.83333H2.83333V19.1667ZM5.16667 12.1667V9.83333H7.5V12.1667H5.16667ZM9.83333 16.8333V14.5H12.1667V16.8333H9.83333ZM9.83333 12.1667V9.83333H12.1667V12.1667H9.83333ZM9.83333 7.5V5.16667H12.1667V7.5H9.83333ZM14.5 12.1667V9.83333H16.8333V12.1667H14.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormat);
export default __webpack_public_path__ + "static/media/icon_format.a19d80aa08d302eb1b7f31183da54ac4.svg";
export { ForwardRef as ReactComponent };